import './App.css';
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from './store';
import HomePage from './pages/Home/home.js';
import ServicePage from './pages/Services/service.js';
import AboutPage from './pages/AboutUs/About.jsx';
import ContactUs from './pages/ContactUs/ContactUs.jsx';
import Header from './components/Header/header.js';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import CareerPage from './pages/Career/career.js';


// Wrapper to conditionally show header
const Layout = ({ children }) => {
  const location = useLocation();
  const noHeaderRoutes = ["/privacy-policy", "/terms-and-conditions"];
  const hideHeader = noHeaderRoutes.includes(location.pathname);

  return (
    <>
      {!hideHeader && <Header />}
      {children}
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Layout>
            <div className="App">
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                toastStyle={{
                  zIndex: 99999,
                  backgroundColor: "#181818",
                }}
              />
              <Helmet>
                <title>BA Code Solutions</title>
                <meta
                  name="description"
                  content="BA Code Solutions provides web development and React-based solutions."
                />
              </Helmet>

              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/career" element={<CareerPage   />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              </Routes> 
            </div>
          </Layout>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
